import * as yup from 'yup';

export default yup.object().shape({
  name: yup.string().required(),
  external_number: yup.number()
    .typeError('Should be a number')
    .required(),
  manager: yup.string().required(),
});
